import { DatePicker } from '@mui/lab';
import { Box, TextField } from '@mui/material';
import { format } from 'date-fns';
import { FilterProps } from 'react-table';
import { Product } from 'shared/types';

export default function DateFilter({ column: { filterValue, setFilter, render, id } }: FilterProps<Product>) {
    return (
        <div>
            <Box display='flex' justifyContent='space-between' alignItems='center'>
                <DatePicker
                    label={`${render('Header')} Since`}
                    value={filterValue?.[0] || undefined}
                    onChange={date => {
                        setFilter([format(date as Date, 'MM-dd-yy')]);
                    }}
                    renderInput={params => <TextField {...params} />}
                    maxDate={new Date()}
                    inputFormat='MM-dd-yy'
                    mask='__-__-__'
                    showTodayButton
                />
            </Box>
        </div>
    );
}
